import { ReactNode, createContext, useContext } from "react";
import { useFilterCampaign } from "./filter-campaign.hook";

const FilterCampaignContext = createContext(
  {} as ReturnType<typeof useFilterCampaign>
);
export function useFilterCampaignContext() {
  return useContext(FilterCampaignContext);
}

interface FilterCampaignProviderProps {
  children: ReactNode;
}
export function FilterCampaignProvider({
  children,
}: FilterCampaignProviderProps) {
  return (
    <FilterCampaignContext.Provider value={useFilterCampaign()}>
      {children}
    </FilterCampaignContext.Provider>
  );
}